import axios from "axios";
import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { BASE_URL } from "../../../services/Api";
import { authHeader } from "../../../services/auth-header";
import Form from "react-bootstrap/Form";
import { Card, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import ViewPumpDomesticSalesEnquiry from "./PumpDomesticSalesEnquiry/ViewPumpDomesticSalesEnuiry";
import ViewPumpInternationalSalesEnquiry from "./PumpInternationalSalesEnquiry/ViewPumpInternationalSalesEnquiry";
import ViewAraiMfgSalesEnquiry from "./AraiMfgSalesEnquiry/ViewAraiMfgSalesEnquiry";
import ViewAraiMfgDomesticSE from "./AraiMfgDomesticSalesEnquiry/ViewAraiMfgDomesticSE";

const ViewSalesEnquiry = () => {
  const navigate = useNavigate();
  const { id, pointindex } = useParams();
  const [productType, setProductType] = useState();
  const [productCategory, setProductCategory] = useState();
  const [enquiryData, setEnquiryData] = useState();

  async function getData() {
    try {
      const response = await axios.get(`${BASE_URL}enquiry/findById/${id}`, {
        headers: authHeader(),
      });

      setEnquiryData(response.data);
      setProductType(response.data.enquirytype);
      setProductCategory(response.data.enquirycategory);
    } catch (error) {
      console.log(error);
    }
  }

  function PageDisplay() {
    if (productType === "Pump Spare") {
      if (productCategory === "Domestic") {
        return <ViewPumpDomesticSalesEnquiry enquiryData={enquiryData} />;
      } else if (productCategory === "International") {
        return <ViewPumpInternationalSalesEnquiry enquiryData={enquiryData} />;
      }
    } else if (productType === "Manufacturing") {
      if (productCategory === "Domestic") {
        return <ViewAraiMfgDomesticSE enquiryData={enquiryData} />;
      } else if (productCategory === "International") {
        return <ViewAraiMfgSalesEnquiry enquiryData={enquiryData} />;
      }
    } else {
      return null;
    }
  }

  async function deleteEnquiry() {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(BASE_URL + "enquiry/delete/" + id, {
            headers: authHeader(),
          })

          .then((response) => {
            if (response.data.length === 0) {
              Swal.fire("Warning", "Enquiry present in another module. Delete operation has been cancelled.", "warning");
            } else {
              console.log(response.data);
              navigate(`/salesEnquiryIndex/${pointindex}`);
              Swal.fire("Deleted!", "Deleted successfully.", "success");
            }
          })
          .catch((error) => {
            Swal.fire("Error", error.response.data, "error");
          });
      }
    });
  }

  async function cancelHandler() {
    try {
      const response = await axios.get(`${BASE_URL}enquiry/enquiryCancelStatus/${id}`, {
        headers: authHeader(),
      });

      navigate(`/salesEnquiryIndex/${pointindex}`);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    getData();
  }, []);

  console.log(enquiryData);

  return (
   
      <Card className="card">
        <Card.Header className="card-header">
          <h6>VIEW SALES ENQUIRY</h6>
          <div className="view-buttons">
            {enquiryData?.status === "Open" && enquiryData?.status !== "Cancelled" && (
              <Link to={`/setosqconversion/${id}`}>
                <button className="button-70">Convert To Sales Quotation</button>
              </Link>
            )}

            {enquiryData?.status !== "Cancelled" && (
              <Link to={`/editSalesEnquiry/${id}/${pointindex}`}>
                <button className="button-70">EDIT</button>
              </Link>
            )}

            {enquiryData?.status === "Open" && enquiryData?.status !== "Cancelled" && (
              <button className="button-70" onClick={cancelHandler}>
                Cancel
              </button>
            )}

            <button className="btn btn-secondary" onClick={() => navigate(-1)}>
              Back
            </button>

            {/* <Link to={`/salesEnquiryIndex/${pointindex}`}>
              <button className="button-70">BACK</button>
            </Link> */}
          </div>
        </Card.Header>
        {PageDisplay()}
      </Card>
  );
};

export default ViewSalesEnquiry;
